(() => {
  const elementName = 'pyp-product-review-gate';
  if (customElements.get(elementName)) return;

  class PypProductReviewGate extends HTMLElement {
    connectedCallback() {
      if (this.dataset.pypLooxGateInitialized === 'true') return;

      const headingSection = this.closest('.shopify-section');
      const findNextShopifySection = (section) => {
        let candidate = section?.nextElementSibling;
        while (candidate && !candidate.classList.contains('shopify-section')) {
          candidate = candidate.nextElementSibling;
        }
        return candidate;
      };
      const adjacentSection = findNextShopifySection(headingSection);
      const appSection = adjacentSection?.querySelector('.pyp-paint-family')
        ? null
        : adjacentSection;
      if (!headingSection || !adjacentSection) return;

      this.dataset.pypLooxGateInitialized = 'true';
      let followingSection = appSection
        ? findNextShopifySection(appSection)
        : adjacentSection;
      let candidate = followingSection;
      while (candidate) {
        if (candidate.querySelector('.pyp-paint-family')) {
          followingSection = candidate;
          break;
        }
        candidate = findNextShopifySection(candidate);
      }
      let checkFrame = null;
      let observer = null;
      let currentState = '';

      const setPendingState = () => {
        if (currentState === 'pending') return;
        currentState = 'pending';
        this.hidden = true;
        headingSection.dataset.pypLooxState = 'pending';
        appSection?.classList.add('pyp-loox-review-app--pending');
        appSection?.setAttribute('aria-hidden', 'true');
        if (appSection) appSection.inert = true;
        followingSection?.classList.add('pyp-loox-review-fallback-next');
      };

      const getReportedHeight = (element) => {
        if (!element) return 0;
        const attributeHeight = Number.parseFloat(element.getAttribute('height') || '');
        const inlineHeight = Number.parseFloat(element.style.height || '');
        return Math.max(attributeHeight || 0, inlineHeight || 0, element.getBoundingClientRect().height || 0);
      };

      const looxIsReady = () => {
        const widget = appSection?.querySelector('#looxReviews.loox-widget[data-upgraded="true"]');
        const frame = widget?.querySelector('iframe#looxReviewsFrame[src*="loox.io/widget/"]');
        if (!widget || !frame) return false;

        return widget.getBoundingClientRect().width >= 240 && getReportedHeight(frame) >= 240;
      };

      const setReadyState = () => {
        if (currentState === 'ready') return;
        currentState = 'ready';
        appSection?.classList.remove('pyp-loox-review-app--pending');
        appSection?.removeAttribute('aria-hidden');
        if (appSection) appSection.inert = false;
        followingSection?.classList.remove('pyp-loox-review-fallback-next');
        headingSection.dataset.pypLooxState = 'ready';
        this.hidden = false;
      };

      const syncState = () => {
        if (looxIsReady()) {
          setReadyState();
        } else {
          setPendingState();
        }
      };

      const scheduleCheck = () => {
        if (checkFrame !== null) return;
        checkFrame = window.requestAnimationFrame(() => {
          checkFrame = null;
          syncState();
        });
      };

      setPendingState();
      if (appSection) {
        observer = new MutationObserver(scheduleCheck);
        observer.observe(appSection, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['class', 'data-upgraded', 'height', 'src', 'style']
        });
      }
      scheduleCheck();

      this.__destroyPypLooxGate = () => {
        observer?.disconnect();
        if (checkFrame !== null) window.cancelAnimationFrame(checkFrame);
        appSection?.classList.remove('pyp-loox-review-app--pending');
        appSection?.removeAttribute('aria-hidden');
        if (appSection) appSection.inert = false;
        followingSection?.classList.remove('pyp-loox-review-fallback-next');
        delete headingSection.dataset.pypLooxState;
        currentState = '';
        delete this.dataset.pypLooxGateInitialized;
        delete this.__destroyPypLooxGate;
      };
    }

    disconnectedCallback() {
      this.__destroyPypLooxGate?.();
    }
  }

  customElements.define(elementName, PypProductReviewGate);
})();
